import axios from 'axios';
import { isInstallerNativeApp } from './installerSms';

/*
 * В APK UI локальный (Capacitor), API — на сервере.
 * В браузере на сайте — относительные /api/...
 */
export const getApiBaseUrl = () => {
    if (isInstallerNativeApp()) {
        return 'https://crm.smartcoms.ru';
    }
    return '';
};

export const apiUrl = path => {
    const base = getApiBaseUrl();
    const normalized = String(path || '').startsWith('/')
        ? String(path)
        : `/${path || ''}`;
    return `${base}${normalized}`;
};

export const setupApiClient = () => {
    const base = getApiBaseUrl();
    axios.defaults.baseURL = base || undefined;
};
